<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加App配置"
      width="800px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="startPageDetail"
        ref="startPageForm"
        class="banner-form"
        :rules="rules"
        label-width="180px"
      >
       
        <div class="flex_div">
        <el-form-item label="配置类型：" prop="confType">
          <el-select v-model="startPageDetail.confType" placeholder="请选择">
            <el-option
              v-for="item in confTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转类型：" prop="type">
          <el-select v-model="startPageDetail.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="flex_div">
        <!-- <el-form-item label="配置类型：" prop="confType">
          <el-select v-model="startPageDetail.confType" placeholder="请选择">
            <el-option
              v-for="item in confTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="平台区分：" prop="platform">
          <el-select v-model="startPageDetail.platform"  placeholder="请选择">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
       
        </div>
       
        <div class="flex_div btn">
          <el-form-item label="是否登录：" prop="login">
            <el-switch
              v-model="startPageDetail.login"
              active-color="#13ce66"
              >
            </el-switch>
          </el-form-item>
          <el-form-item label="是否开启：" prop="confOpen">
            <el-switch
              v-model="startPageDetail.confOpen"
              active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
        </div>
         <el-form-item label="显示名称：" prop="displayName">
          <el-input v-model="startPageDetail.displayName"></el-input>
        </el-form-item>
        <el-form-item label="icon图标" prop="icon">
          <upload v-model="confObj.icon" :data="query"></upload>
        </el-form-item>
        <div class="flex_div">
          <el-form-item label="地址选择：" prop="urlType" class="url">
            <el-select v-model="urlType" 
            @change="changeUrl($event)"
            placeholder="请选择地址" 
            class="url_select">
              <el-option
                v-for="item in urloptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          <el-input v-model="urlDetail" style="width: 358px;"></el-input>
        </el-form-item>
        </div>
        
        <div class="flex_div">
           <el-form-item label="最低版本：" prop="verL">
          <el-input v-model="startPageDetail.verL"></el-input>
        </el-form-item>
        <el-form-item label="最高版本：" prop="verH">
          <el-input v-model="startPageDetail.verH"></el-input>
        </el-form-item>
        </div>
       
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('startPageForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Upload from "components/upload";

export default {
  name: "CreateBanner",
  props: ["value"],
  data() {
    return {
      dialogVisible: false,
      urlType:'url',
      urlDetail:'',
      confObj:{},
      urloptions:[
        {   
          value: 'url',
          label: "全局地址(url)",
        },
        {   
          value: 'urlAppend',
          label: "相对地址(urlAppend)",
        },
      ],
      confTypeOptions:[
       {   
          value: '1',
          label: "启动页(1)",
        },
       {   
          value: '2',
          label: "广告页(2)",
        },
       {   
          value: '3',
          label: "金刚区(3)",
        },
      ],
      platformOptions:[
        {   
          value: '0',
          label: "安卓(0)",
        },
       {   
          value: '1',
          label: "苹果(1)",
        },
      ],
      startPageDetail: {
        platform:[],
        confValue:[]
      },

      rules: {
        confType: [{ required: true, message: "配置类型不能为空！" }],
        // icon: [{ required: true, message: "图标地址不能为空！" }],
        title: [{ required: true, }],
        type: [{ required: true, message: "跳转类型(app内部模块)不能为空！" }],
        displayName: [{ required: true, message: "显示名称不能为空！" }],
       
      },
      options: [
        {
          value: '1',
          label: "H5",
        },
        {
          value: '2',
          label: "移动端",
        },
      ],
    };
  },
  components: {
    Upload,
  },
  computed: {
    ...mapState("startPageSetting", [
      "positionTypeList",
      "platformTypeList",
      "languageList",
      "query",
      "bannerTypes",
    
    ]),
    ...mapGetters("startPageSetting", ["bannerList"]),
  },
  methods: {
    ...mapActions("startPageSetting", ["create", "list",'getStartPageAdd']),
    closeDialog() {
      this.dialogVisible = false;
      this.startPageDetail = {};
      this.$refs["startPageForm"].resetFields();
    },
    changeUrl(e){
        this.urlType=e
        // this.urlDetail=''
        this.$set(this.confObj,this.urlType,this.urlDetail)
        this.startPageDetail={
          ...this.startPageDetail,
          confValue:[{...this.confObj}],
         

        }
    },
    handleSave(formName) {
       this.$set(this.confObj,this.urlType,this.urlDetail)
        this.startPageDetail={
          ...this.startPageDetail,
          confValue:[{...this.confObj}],
           login:Number(this.startPageDetail.login),
          confOpen:Number(this.startPageDetail.confOpen),
        }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.create({ ...this.query, ...this.startPageDetail }).then(() => {
          //   this.$message({
          //     message: "添加成功！",
          //     type: "success",
          //   });
          //   this.dialogVisible = false;
          //   this.$emit("refresh");
          // });
          this.getStartPageAdd({...this.query,...this.startPageDetail}).then(res=>{
               this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.dialogVisible = false;
             this.$emit("refresh");
          })
        }
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
.btn{
  justify-content: space-between;
}
.url{
  justify-content: space-between;
}
.url_select{
  width: 120px;
}
</style>
